import { Alpine, Livewire } from '../../vendor/livewire/livewire/dist/livewire.esm';
import { registerAudioPlayer } from './audio_player';

document.addEventListener('alpine:initializing', () => {
  Alpine.data('main', () => ({
    showSearch: false,
    showMobileNavigation: false,
    headerScrolledAway: false,
  }));

  Alpine.store('map', {
    styleUrl: 'https://tiles.openfreemap.org/styles/liberty',
  });

  registerAudioPlayer(Alpine, Livewire);
});

// Lets page bundles loaded later by an SPA navigation register their Alpine components
// immediately (see alpine_helpers.js).
document.addEventListener('alpine:init', () => (window.alpineStarted = true));

Livewire.start();
